var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "slider-container" },
    [
      _c(
        "slick",
        { ref: "slider", attrs: { options: _vm.slickOptions } },
        [_vm._t("default")],
        2
      ),
      !_vm.arrows
        ? _c("div", { staticClass: "slider-arrows" }, [
            _c(
              "a",
              {
                staticClass: "slider-arrow prev",
                on: {
                  click: function($event) {
                    _vm.prev()
                  }
                }
              },
              [
                _c("i", {
                  staticClass: "fa fa-angle-up",
                  attrs: { "aria-hidden": "true" }
                })
              ]
            ),
            _c(
              "a",
              {
                staticClass: "slider-arrow next",
                on: {
                  click: function($event) {
                    _vm.next()
                  }
                }
              },
              [
                _c("i", {
                  staticClass: "fa fa-angle-down",
                  attrs: { "aria-hidden": "true" }
                })
              ]
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0e1b12bd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e1b12bd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/shared/sliders/Slider.vue
// module id = cHUi
// module chunks = 41